import jQuery from 'jquery';

// Control header fixed state
let headerHeightFromTop;

const $html = jQuery('html');
const $headerContainer = jQuery('[data-target=primary-header-container]');
const $header = jQuery('[data-target=primary-header]');

// get y position of header container from top of screen
function getHeaderYPos() {
  return $headerContainer.offset().top;
}

// on scroll check if header should be fixed
jQuery(window)
  .on('scroll', function() {
    const scrollPosition = jQuery(this).scrollTop();

    /*  on scroll check to make sure that the header container
      yPos is still accurate, it can change from on
      load due to slow banners loading, new banners etc..... */
    headerHeightFromTop = getHeaderYPos();

    /*  once the top of the screen hits the top of the header container,
      make the header sticky */
    if (
      scrollPosition >= headerHeightFromTop &&
      !$html.hasClass('is-fixed-header')
    ) {
      if (
        typeof window.hideStickyNav === 'undefined' ||
        (typeof window.hideStickyNav !== 'undefined' &&
          window.hideStickyNav === false)
      ) {
        // only make the header sticky when "hideStickyNav" is undefined or
        // false
        $html.addClass('is-fixed-header');
      }
    } else if (
      scrollPosition < headerHeightFromTop &&
      $html.hasClass('is-fixed-header')
    ) {
      $html.removeClass('is-fixed-header');
    }

    /*  add a class on scroll to allow us to give the header a different visual
   state */
    if (scrollPosition > 0 && !$header.hasClass('is-scrolled')) {
      $header.addClass('is-scrolled');
    } else if (scrollPosition === 0 && $header.hasClass('is-scrolled')) {
      $header.removeClass('is-scrolled');
    }
  })
  .on('resize', () => {
    /*  on screen resize make sure the content above the header container
  hasn't changed height, changing the headers yPos */
    headerHeightFromTop = getHeaderYPos();
  });
